import {
  Box,
  HStack,
  Text,
  VStack,
  BoxProps,
  TextProps,
} from "@chakra-ui/react";
import { ArrowDownIcon, ArrowUpIcon } from "@chakra-ui/icons";

const StatCard = ({
  title,
  value,
  info,
  percentage,
  isKYD = false,
  highlight = false,
  valueFontSize = "24px",
  textProps = {},
  ...props
}: {
  title: string;
  value: number | string;
  info?: string;
  percentage?: number;
  isKYD?: boolean;
  highlight?: boolean;
  valueFontSize?: string;
  textProps?: TextProps;
} & BoxProps) => {
  const isPositive = percentage >= 0;
  return (
    <VStack
      background="linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(180deg, rgba(231, 233, 239, 0.01) 0%, #FFFFFF 100%)"
      boxShadow="0px 4px 12px -5px #00000009, 0px 1px 2px 0px #FFFFFFBF inset"
      position="relative"
      border={"1px solid #DDDDDD"}
      borderRadius={"10px"}
      alignItems={"flex-start"}
      justifyContent={"space-between"}
      p={[2, 3]}
      width={"100%"}
      lineHeight={"100%"}
      {...props}
    >
      <HStack gap={"4px"} w="100%" minW={0}>
        {highlight && (
          <Box
            bgColor={"#C0DC26F5"}
            width={"10px"}
            height={"10px"}
            borderRadius={100}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexShrink={0}
          />
        )}
        <Text
          fontSize={"13px"}
          fontWeight={"500"}
          color={"#666666"}
          flex={1}
          minW={0}
          noOfLines={2}
        >
          {title}
        </Text>
      </HStack>
      <HStack minW={0} w="100%" alignItems="flex-start">
        <Text
          fontSize={valueFontSize}
          fontWeight={"400"}
          lineHeight={"24px"}
          minW={0}
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          noOfLines={1}
          {...textProps}
        >
          {value}
        </Text>
        {info && (
          <Text
            fontSize={"12px"}
            fontWeight={"400"}
            color={"#718096"}
            height={2.5}
          >
            {info}
          </Text>
        )}
        {percentage && (
          <Text
            color={isPositive ? "#6DCB24" : "#718096"}
            fontSize={"12px"}
            fontWeight={"600"}
          >
            {isPositive ? (
              <ArrowUpIcon mb={0.5} color="#6DCB24" />
            ) : (
              <ArrowDownIcon mb={0.5} color="#718096" />
            )}
            {percentage}%
          </Text>
        )}
      </HStack>
      {isKYD && (
        <Box
          position="absolute"
          top={"8px"}
          right={"8px"}
          bgColor={"#D3F227"}
          width={"28px"}
          height={"28px"}
          borderRadius={8}
          border={"1px solid #C0DC26BF"}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <img
            src="/crown.png"
            alt="KYD"
            style={{ opacity: "0.70" }}
            width={16}
          />
        </Box>
      )}
    </VStack>
  );
};
export default StatCard;
